<template>
  <div class="vis-map--full">
<!--    <vis-map-view-->
<!--      auto-center-->
<!--      yandex-tile-->
<!--      google-tile-->
<!--      :preset-id="userPresetId"-->
<!--      filtering-->
<!--      @popup:details="onPopupDetails"-->
<!--      @filter="onFilter"-->
<!--      @editor:create="handleEditorCreate"-->
<!--      :popup-actions="fetchPopupActions"-->
<!--      @popup:action="onPopupAction"-->
<!--      :editorAutoOpenPopup="false"-->
<!--      :itemFitPointAround="100"-->
<!--      :noAuth="noAuth"-->
<!--      :can-edit="false"-->
<!--      :sputnikLabel="null"-->
<!--      :cadastreLabel="null"-->
<!--      :tile="'Jawg.Terrain'"-->
<!--      print-with-sidebar-->
<!--    >-->
<!--      <template #other-tiles>-->
<!--        <v-map-wms-tile-layer-->
<!--          v-for="item in customLayers"-->
<!--          :key="item.ID"-->
<!--          :name="item.Title"-->
<!--          :layers="item.Layers"-->
<!--          :format="item.Format"-->
<!--          :crs="getCrsObject(item.Crs)"-->
<!--          :url="item.Url"-->
<!--          transparent-->
<!--          layer-type="overlay"-->
<!--        />-->
<!--        <v-map-tile-layer name="Jawg.Terrain" :url="jawgTerrainUrl" />-->
<!--        <v-map-wms-tile-layer-->
<!--          :name="$t('local')"-->
<!--          url="http://172.17.100.187:8082/geoserver/gwc/service/wms"-->
<!--          layers="osm:osm_ru"-->
<!--          format="image/png"-->
<!--          transparent-->
<!--        />-->
<!--        &lt;!&ndash; <v-map-wms-tile-layer-->
<!--          layer-type="overlay"-->
<!--          name="Метеоданные (Grib)"-->
<!--          layers="rgm:rgm_temp_above_ground"-->
<!--          transparent-->
<!--          format="image/png"-->
<!--          url="http://georgm.pba.su/geoserver/gwc/service/wms"-->
<!--        />-->
<!--        <v-map-wms-tile-layer-->
<!--          :crs="L.CRS.EPSG4326"-->
<!--          format="image/png8"-->
<!--          layer-type="overlay"-->
<!--          layers="rgm:grprgm"-->
<!--          name="Метеоданные (Grib) 2"-->
<!--          transparent-->
<!--          url="http://georgm.pba.su/geoserver/rgm/wms"-->
<!--          version="1.0.0"-->
<!--        /> &ndash;&gt;-->
<!--        <v-map-tile-layer-->
<!--          name="GISWebServiceSE"-->
<!--          url="http://172.17.100.72/GISWebServiceSE/service.php?REQUEST=GetTile&SERVICE=wmts&VERSION=1.0.0&LAYER=ru-mos&STYLE=default&FORMAT=image/png&tilematrixset=urn:ogc:def:wkss:OGC:1.0:GoogleMapsCompatible&tilerow={y}&tilecol={x}&tilematrix={z}"-->
<!--        />-->
<!--      </template>-->
<!--      <template v-slot:popup-other-content="{ layerId, layerType, content }">-->
<!--        <vis-map-custom-popup-content-->
<!--          :layer-type="layerType"-->
<!--          :layer-id="layerId"-->
<!--          :content="content"-->
<!--        />-->
<!--      </template>-->
<!--    </vis-map-view>-->
<!--    <vis-detail-view-dialog-->
<!--      v-if="dvCrudService !== null"-->
<!--      :mnemonic="dvMnemonic"-->
<!--      :crud-service="dvCrudService"-->
<!--      :visible="dvVisible"-->
<!--      @hide="detailViewOnCancel"-->
<!--      @save="detailViewOnSave"-->
<!--    />-->
<!--    <vis-filter-dialog-->
<!--      v-if="dvMnemonic && filterModel"-->
<!--      :mnemonic="dvMnemonic"-->
<!--      :filter="currentQueryFilter"-->
<!--      :model="filterModel"-->
<!--      :visible="filterVisible"-->
<!--      @apply="onFilterApply"-->
<!--      @hide="filterVisible = false"-->
<!--    />-->
<!--    <vis-reports-dialog-->
<!--      v-if="reportsDialogVisible"-->
<!--      :mnemonic="reportMnemonic"-->
<!--      :visible="reportsDialogVisible"-->
<!--      @hide="onReportsDialogHide"-->
<!--      :entity-id="reportEntityId"-->
<!--    />-->
<!--    <vis-gistracker-history-dialog-->
<!--      v-if="trackHistoryDialog.trackerId"-->
<!--      :visible.sync="trackHistoryDialog.visible"-->
<!--      :tracker-id="trackHistoryDialog.trackerId"-->
<!--    />-->

    <iframe
      class="vis-map__frame"
      height="100%"
      width="100%"
      :src="mapSrc"
    ></iframe>
  </div>
</template>

<script>
import { VMapWmsTileLayer, VMapTileLayer } from "@rosgidromet/visary-map-vue-rgm";
import RemoteCrudService from "@/shared/services/remote-crud-service";
import api from "@/api/visary-api";
import logger from "@/shared/log";
import FilterRegister from "@/views/base/filter/js/register/filter-register";
import loadYandexGoogleMap from "@/shared/load-yandex-google-map";
import globalState from "@/shared/global-state";
import rhmApi from "@/api/rhm-api";
import L from "leaflet";

const TRACKER_LAYER_TYPE = 5;

export default {
  name: "vis-map",
  props: {
    noAuth: { type: Boolean, default: false },
  },
  components: {
    VMapWmsTileLayer,
    VMapTileLayer,
  },
  data() {
    return {
      L,
      reportsDialogVisible: false,
      reportEntityId: null,
      popupActions: [
        {
          id: "report",
          icon: "far fa-file-alt",
          title: this.$t("detailView.openReportsDialog"),
        },
      ],
      trackHistoryAction: {
        id: "history",
        icon: "far fa-history",
        title: this.$t("detailView.openTrackHistoryDialog"),
      },
      reportMnemonic: null,
      dvMnemonic: null,
      dvCrudService: null,
      dvVisible: false,
      currentQueryFilter: null,
      filterModel: null,
      filterVisible: false,
      filterCallback: null,
      dvSaveCallback: null,
      dvCancelCallback: null,
      userPresetId: null,
      filtersDictionary: {},
      trackHistoryDialog: {
        visible: false,
        trackerId: null,
      },
      customLayers: null,
      mapSrc: process.env.VUE_APP_MT_MAP_SOURCE
    };
  },
  async created() {
    // loadYandexGoogleMap();
    // this.customLayers = await rhmApi.mapLayer.getMapLayers();
    // await this.fetchCurrentPreset();
  },
  computed: {
    // jawgTerrainUrl() {
    //   return (
    //     "https://{s}.tile.jawg.io/jawg-terrain/{z}/{x}/{y}{r}.png?access-token=" +
    //     globalState?.launchConfig?.jawgAccessToken
    //   );
    // },
  },
  methods: {
    async fetchCurrentPreset() {
      try {
        this.userPresetId = (await api.map.currentUserPresetId()) || null;
      } catch (e) {
        logger.error(e);
      }
    },
    async getModel(mnemonic) {
      let serverFilterModel = await api.queryTreeFilter.getModel(
        mnemonic,
        "mnemonic"
      );
      const modelItems = [];
      if (
        serverFilterModel &&
        serverFilterModel.Items &&
        serverFilterModel.Items.length
      ) {
        for (let i = 0; i < serverFilterModel.Items.length; i++) {
          const filterInfo = serverFilterModel.Items[i];
          if (FilterRegister[filterInfo.Type]) {
            let filterData = {
              dataField: filterInfo.Id,
              caption: filterInfo.Title,
              filterOperations: [],
              editorOptions: {
                viewComponent: filterInfo.Params,
                modelType: filterInfo.Type,
              },
            };

            if (FilterRegister[filterInfo.Type].dataType) {
              filterData.dataType = FilterRegister[filterInfo.Type].dataType;
            }

            if (FilterRegister[filterInfo.Type].filterOperations) {
              filterData.filterOperations = filterData.filterOperations.concat(
                FilterRegister[filterInfo.Type].filterOperations
              );
            }

            if (FilterRegister[filterInfo.Type].onlyDialogFilterOperations) {
              filterData.filterOperations = filterData.filterOperations.concat(
                FilterRegister[filterInfo.Type].onlyDialogFilterOperations
              );
            }

            if (FilterRegister[filterInfo.Type].calculateFilterExpression) {
              filterData.calculateFilterExpression =
                FilterRegister[filterInfo.Type].calculateFilterExpression;
            }

            if (FilterRegister[filterInfo.Type].customizeText) {
              filterData.customizeText =
                FilterRegister[filterInfo.Type].customizeText;
            }

            if (FilterRegister[filterInfo.Type].lookup) {
              filterData.lookup = {
                dataSource: FilterRegister[filterInfo.Type].lookup.dataSource(
                  filterInfo.Params
                ),
                displayExpr:
                  FilterRegister[filterInfo.Type].lookup.displayExpr ?? "Title",
                valueExpr:
                  FilterRegister[filterInfo.Type].lookup.valueExpr ?? "ID",
              };
            }

            modelItems.push(filterData);
          }
        }
      }
      return modelItems;
    },
    async fetchPopupActions(layerData) {
      if (layerData.type === TRACKER_LAYER_TYPE) {
        return [...this.popupActions, this.trackHistoryAction];
      }
      return this.popupActions;

      /*const reports = await api.reporting.reportsByType(layerData.id);
      const dashboards = await api.reporting.dashboardsByType(layerData.id);

      if (
        reports &&
        dashboards &&
        reports.length > 0 &&
        dashboards.length > 0
      ) {
        return this.popupActions;
      } else {
        return [];
      }*/
    },
    addToFiltersDictionary(filter) {
      if (this.dvMnemonic) {
        this.filtersDictionary[this.dvMnemonic] = filter;
      }
    },
    setCurrentFilterFromFiltersDictionary() {
      if (this.filtersDictionary.hasOwnProperty(this.dvMnemonic)) {
        this.currentQueryFilter = this.filtersDictionary[this.dvMnemonic];
      } else {
        this.currentQueryFilter = { Scheme: [], Expression: null };
      }
    },
    handleEditorCreate(e) {
      this.dvSaveCallback = e.done;
      this.dvCancelCallback = e.cancel;
      this.openDetailView(e.layerId, 0, e.geometry);
    },
    detailViewOnCancel() {
      this.dvVisible = false;
      if (this.dvCancelCallback) {
        this.dvCancelCallback();
      }
    },
    detailViewOnSave() {
      if (this.dvSaveCallback) {
        this.dvSaveCallback();
      }
    },
    onFilterApply(filter) {
      this.filterVisible = false;
      this.addToFiltersDictionary(filter);
      let filterExpression =
        filter && filter.Expression && filter.Expression.length
          ? JSON.stringify(filter.Expression)
          : null;
      this.filterCallback(filterExpression);
    },
    onPopupDetails(e) {
      this.dvSaveCallback = e.done;
      this.dvCancelCallback = null;
      this.openDetailView(e.layerData.mnemonic, e.data.id);
    },
    openDetailView(layerMnemonic, id, geoJson = null) {
      this.dvMnemonic = layerMnemonic;
      this.dvCrudService = new RemoteCrudService(this.dvMnemonic);
      if (geoJson) {
        this.addDefaultLocation(geoJson);
      }
      this.dvCrudService.setId(id);
      this.dvVisible = true;
    },
    addDefaultLocation(geoJson) {
      this.dvCrudService.addDefaultValue("Location", {
        Address: null,
        Disposition: geoJson,
        BoundMinY: 0,
        BoundMinX: 0,
        BoundMaxY: 0,
        BoundMaxX: 0,
        HasBounds: false,
        CenterPointY: 0,
        CenterPointX: 0,
        HasCenterPoint: false,
        Cluster: null,
        ZoomLevel: 0,
      });
    },
    async onFilter(e) {
      this.dvMnemonic = e.layerData.mnemonic;
      this.filterModel = await this.getModel(this.dvMnemonic);
      this.setCurrentFilterFromFiltersDictionary();
      this.filterCallback = e.done;
      this.filterVisible = true;
    },
    onReportsDialogHide() {
      this.reportsDialogVisible = false;
    },
    onPopupAction(event) {
      if (event.action.id === "report") {
        this.reportMnemonic = event.layerData.mnemonic;
        this.reportEntityId = event.data.id;
        this.reportsDialogVisible = true;
      } else if (event.action.id === "history") {
        this.trackHistoryDialog.trackerId = event.data.trackerId;
        this.trackHistoryDialog.visible = true;
      }
    },
    getCrsObject(key) {
      if (key && L.CRS[key]) {
        return L.CRS[key];
      }
      return undefined;
    }
  },
};
</script>

<style lang="scss">
.vis-map {
  &__frame {
    transform-origin: 0 0;
    transform: scale(0.7);
    height: 143%;
    width: 143%;
  }
}
</style>
